export default __webpack_public_path__ + "static/media/0004.c1d86b1c.jpg";